import React from 'react';

import EmptyGoodsIcon from 'assets/empty-goods-icon';
import useTranslation from 'hooks/use-translation';
import useProductQueryParams from 'hooks/use-product-query-params';

import { EmptyStateContainer, StyledHeader, StyledSubtext, StyledTextButton } from './empty-state-shared-styles';

const CategoryPageEmptyState = () => {
  const { t } = useTranslation();
  const { resetQueryParams } = useProductQueryParams();

  return (
    <EmptyStateContainer>
      <EmptyGoodsIcon />
      <StyledHeader>{t('categoryPageEmptyState.header', "We couldn't find what you're looking for")}</StyledHeader>
      <StyledSubtext>
        {t('categoryPageEmptyState.subtext', "There aren't any products that match your search. Try again!")}
      </StyledSubtext>
      <StyledTextButton onClick={resetQueryParams}>
        {t('categoryPageEmptyState.clearYourSearch', 'Clear your search')}
      </StyledTextButton>
    </EmptyStateContainer>
  );
};

export default CategoryPageEmptyState;
